import { memo } from 'react'
import { ImportDynamicallyEdit } from './ImportDynamicallyEdit'
import AsyncLocalStorage from '@createnextapp/async-local-storage'

const getValueFromConfig = (config) => {
  if (Object.hasOwn(config, 'reactAdmin')) {
    const { folder, file } = config.reactAdmin?.components.user.edit
    return { folder, file }
  }
}

export const FieldsByApplicationEdit = memo((props) => {
    if (props.config) {
      if (Object.entries(props.config).length !== 0) {
          let data = getValueFromConfig(props.config)
          if (data) {
            ;(async () => {
              try {
                await AsyncLocalStorage.setItem('dataImportEdit', JSON.stringify(data))
              } catch (e) {
              }
            })()

            return <ImportDynamicallyEdit {...props} />
          }
        }
    }
})
